import { ActivityFeedDomain } from '../../../services/modules/activityFeed/activityFeed.types';
import { ACTIVITY_FEED_FILTER_SEARCH_PARAMS } from '../../activity-feed/activityFeed.constants';
import { ORDER_OBJECT_TAB } from '../orders.constants';
import { getOrderTabPath } from './orderTabPath.utils';

interface GetOrderActivitiesTabPathParams {
  orderId: string;
  domain?: ActivityFeedDomain[];
}

export const getOrderActivitiesTabPath = ({ orderId, domain }: GetOrderActivitiesTabPathParams) =>
  getOrderTabPath({
    orderId,
    tab: ORDER_OBJECT_TAB.ACTIVITIES,
    params: (domain ?? []).map((value) => [ACTIVITY_FEED_FILTER_SEARCH_PARAMS.domain, value]),
  });
